import { FC } from "react";
import styled from "styled-components";

const LogoContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  object-fit: contain;
`;

const Logo: FC = () => {
  return (
    <LogoContainer>
      <img alt="Logo" src="/img/graia-appbar-logo.svg" height={30} width={70} />
    </LogoContainer>
  );
};

export default Logo;
